/* eslint-disable */
import { PluginContainerData, Link } from './common';
import { ButtonData_Type } from './plugin_button.enums';
export function buttonData_TypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'LINK':
            return ButtonData_Type.LINK;
        case 1:
        case 'ACTION':
            return ButtonData_Type.ACTION;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ButtonData_Type.UNRECOGNIZED;
    }
}
export function buttonData_TypeToJSON(object) {
    switch (object) {
        case ButtonData_Type.LINK:
            return 'LINK';
        case ButtonData_Type.ACTION:
            return 'ACTION';
        default:
            return 'UNKNOWN';
    }
}
const baseButtonData = { type: ButtonData_Type.LINK };
export const ButtonData = {
    fromJSON(object) {
        const message = Object.assign({}, baseButtonData);
        message.containerData =
            object.containerData !== undefined && object.containerData !== null
                ? PluginContainerData.fromJSON(object.containerData)
                : undefined;
        message.type =
            object.type !== undefined && object.type !== null
                ? buttonData_TypeFromJSON(object.type)
                : ButtonData_Type.LINK;
        message.styles =
            object.styles !== undefined && object.styles !== null
                ? ButtonData_Styles.fromJSON(object.styles)
                : undefined;
        message.text =
            object.text !== undefined && object.text !== null ? String(object.text) : undefined;
        message.link =
            object.link !== undefined && object.link !== null ? Link.fromJSON(object.link) : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.containerData !== undefined &&
            (obj.containerData = message.containerData
                ? PluginContainerData.toJSON(message.containerData)
                : undefined);
        message.type !== undefined && (obj.type = buttonData_TypeToJSON(message.type));
        message.styles !== undefined &&
            (obj.styles = message.styles ? ButtonData_Styles.toJSON(message.styles) : undefined);
        message.text !== undefined && (obj.text = message.text);
        message.link !== undefined && (obj.link = message.link ? Link.toJSON(message.link) : undefined);
        return obj;
    },
};
const baseButtonData_Styles = {};
export const ButtonData_Styles = {
    fromJSON(object) {
        const message = Object.assign({}, baseButtonData_Styles);
        message.border =
            object.border !== undefined && object.border !== null
                ? ButtonData_Styles_Border.fromJSON(object.border)
                : undefined;
        message.colors =
            object.colors !== undefined && object.colors !== null
                ? ButtonData_Styles_Colors.fromJSON(object.colors)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.border !== undefined &&
            (obj.border = message.border ? ButtonData_Styles_Border.toJSON(message.border) : undefined);
        message.colors !== undefined &&
            (obj.colors = message.colors ? ButtonData_Styles_Colors.toJSON(message.colors) : undefined);
        return obj;
    },
};
const baseButtonData_Styles_Colors = {};
export const ButtonData_Styles_Colors = {
    fromJSON(object) {
        const message = Object.assign({}, baseButtonData_Styles_Colors);
        message.text =
            object.text !== undefined && object.text !== null ? String(object.text) : undefined;
        message.border =
            object.border !== undefined && object.border !== null ? String(object.border) : undefined;
        message.background =
            object.background !== undefined && object.background !== null
                ? String(object.background)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.text !== undefined && (obj.text = message.text);
        message.border !== undefined && (obj.border = message.border);
        message.background !== undefined && (obj.background = message.background);
        return obj;
    },
};
const baseButtonData_Styles_Border = {};
export const ButtonData_Styles_Border = {
    fromJSON(object) {
        const message = Object.assign({}, baseButtonData_Styles_Border);
        message.width =
            object.width !== undefined && object.width !== null ? Number(object.width) : undefined;
        message.radius =
            object.radius !== undefined && object.radius !== null ? Number(object.radius) : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.width !== undefined && (obj.width = message.width);
        message.radius !== undefined && (obj.radius = message.radius);
        return obj;
    },
};
//# sourceMappingURL=plugin_button.js.map